import React from "react";
import PropTypes from "prop-types";
import {
  useMediaQuery,
  Anchor,
  Button,
  Type
} from "@ebscois/react-component-library";

import { returnToUrlClickHandler } from "../../utils/returnToUrlClickHandler";
import {
  ButtonWrapper,
  CallToActionContainer,
  PrimaryMessageLeadIn
} from "./CallToAction.styled";

const CallToActionButton = (button, buttonName, clickHandlers) => {
  if (button) {
    return (
      <Button
        {...button.props}
        onClick={(e) => {
          clickHandlers[button.clickHandler.name](
            e,
            button.clickHandler.parameters
          );
        }}
        data-testid={`cta-${buttonName}`}
      >
        {button.text}
      </Button>
    );
  } else {
    return <></>;
  }
};

const CallToActionLowerText = (paragraph2, link, clickHandlers) => {
  if (paragraph2 || link) {
    return (
      <Type element="p" data-testid="cta-paragraph2">
        {paragraph2 && <>{paragraph2.text} </>}
        {link?.text &&
          link.props?.href &&
          link.clickHandler?.parameters?.url && (
            <Anchor
              data-testid="cta-link"
              href={link.props.href}
              onClick={(e) => {
                clickHandlers[link.clickHandler.name](
                  e,
                  link.clickHandler.parameters
                );
              }}
            >
              {link.text}
            </Anchor>
          )}
      </Type>
    );
  } else {
    return <></>;
  }
};

const CallToAction = ({ cta }) => {
  const isMobile = useMediaQuery("max", "sm");
  const clickHandlers = {
    returnToUrlClickHandler: (e, { url }) => {
      returnToUrlClickHandler(e, url);
    }
  };

  const { italicized, paragraph1, paragraph2, button, buttonBenjamin, link } =
    cta;
  return (
    <CallToActionContainer>
      <div>
        {italicized && (
          <>
            <PrimaryMessageLeadIn
              element="i"
              display={isMobile ? "block" : "inline"}
              data-testid="cta-primaryleadin"
            >
              {italicized.text}
            </PrimaryMessageLeadIn>{" "}
          </>
        )}
        {paragraph1 && (
          <Type
            element="span"
            display={isMobile ? "block" : "inline"}
            data-testid="cta-primary"
          >
            <span dangerouslySetInnerHTML={{ __html: paragraph1.text }}></span>
          </Type>
        )}
      </div>
      <ButtonWrapper>
        {CallToActionButton(buttonBenjamin, "buttonBenjamin", clickHandlers)}
        {CallToActionButton(button, "button", clickHandlers)}
      </ButtonWrapper>
      {CallToActionLowerText(paragraph2, link, clickHandlers)}
    </CallToActionContainer>
  );
};

CallToAction.displayName = "CallToAction";
CallToAction.propTypes = {
  cta: PropTypes.object
};
export default CallToAction;
